<td></td>
<td>{{supplier.lastName}}</td>
<td>{{supplier.firstName}}</td>
<td>{{supplier.email}}</td>
<td>{{supplier.phone}}</td>
<td>
    <span *ngFor="let tag of supplier.tags"
        class="badge py-1 px-2 me-1 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
        {{ tag.name }}
    </span>
</td>
<td>
    <i *ngIf="supplier.emailVerified" class="fas fa-user-check" placement="left"
        ngbTooltip="Active supplier on JetFuelTenders.com"></i>
    <i *ngIf="!supplier.emailVerified" class="fas fa-user-times" placement="left"
        ngbTooltip="This user hasn't yet activated their JetFuelTenders.com account"></i>
</td>
<td class="text-end">
    <div ngbDropdown class="d-inline-block" placement="bottom-end">
        <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
            <i class="fas fa-ellipsis-v"></i>
        </button>
        <div ngbDropdownMenu>
            <h6 class="dropdown-header">User Actions</h6>
            <button ngbDropdownItem (click)="editSupplier(supplier)">
                <i class="fas fa-pen me-2 text-muted"></i> Edit Contact
            </button>
            <div class="dropdown-divider"></div>
            <button ngbDropdownItem class="text-danger" (click)="archive(supplier)">
                <i class="fas fa-user-minus me-2"></i> Remove
            </button>
        </div>
    </div>
</td>
